import { LIVESHOW_SCHEDULES } from "../types";

export const liveshowSheduleReducer = (state = [], action) => {
	const { type, payload } = action;

	switch (type) {
		case LIVESHOW_SCHEDULES: {
			const { data } = payload;
			return data;
		}
		default: {
			return state;
		}
	}
};
